import { Container, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/CloseOutlined";
import React, { useContext } from "react";
import { GlobalContext } from "../context/hoa-global-context";

const ZipModal = ({ open, onClose }: any) => {
	const { selectedValues } = useContext<any>(GlobalContext);
	const zips = selectedValues["municipality"]?.zip?.split(",");

	return (
		<Modal open={open} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "450px",
					maxHeight: "645px",
					overflow: "auto",
					padding: "0px",
				}}
			>
				<div>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "baseline",
							backgroundColor: "#EFF4FC",
							padding: "24px",
						}}
					>
						<div>
							<h3 style={{ color: "#3E3E3E" }}>View Zip</h3>
							<p>
								Showing all zip code for municipality-
								{selectedValues["municipality"].name}
							</p>
						</div>
						<IconButton onClick={() => onClose()}>
							<CloseIcon style={{ cursor: "pointer" }} />
						</IconButton>
					</div>
					<div style={{ padding: "24px" }}>
						<span>Total Zip: {zips.length}</span>
						<hr />
						{zips &&
							zips.map((zip: any, index: number) => <span key={index}>{zip},</span>)}
					</div>
				</div>
			</Container>
		</Modal>
	);
};

export default ZipModal;
